import { CircularProgress as CircularProgressIcon } from '@mui/material';

export const LoadingIcon = () => {
  return (
    <CircularProgressIcon
      size={24}
      sx={{
        position: 'absolute',
        right: 10,
      }}
    />
  );
};
